import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/** Счётчик Яндекс.Метрики (SPA) */
export const YANDEX_METRIKA_ID = 111214511;

/**
 * SPA: init в index.html, здесь — hit при каждой смене URL.
 */
export function YandexMetrika() {
  const location = useLocation();
  const prevUrl = useRef<string | null>(null);
  const isFirst = useRef(true);

  useEffect(() => {
    const url = window.location.href;

    // Первый просмотр уже уходит из init в index.html
    if (isFirst.current) {
      isFirst.current = false;
      prevUrl.current = url;
      return;
    }

    const referer = prevUrl.current ?? undefined;
    prevUrl.current = url;

    if (typeof window.ym !== 'function') return;

    window.ym(YANDEX_METRIKA_ID, 'hit', url, {
      title: document.title,
      referer,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
